import * as React from 'react';

import { Route, Redirect } from 'react-router-dom';
import { isNullOrUndefined } from 'util';
import moment from 'moment';

var packageJson: any = require('../package.json');
var isLatestBuildDate = false;
const buildDateGreaterThan = (latestDate, currentDate) => {
    const momLatestDateTime = moment(latestDate);
    const momCurrentDateTime = moment(currentDate);

    if (momLatestDateTime.isAfter(momCurrentDateTime)) {
        return true;
    } else {
        return false;
    }
};
const refreshCacheAndReload = () => {
    if (caches) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then((names) => {
            for (const name of names) {
                caches.delete(name);
            }
        });
    }
    // delete browser cache and hard reload
    window.location.reload();
};
export const PrivateRoute = ({ component: Component, layout: Layout, path: Path, ...rest }) => {
    //fetch("/meta.json?${new Date().getTime()}, { cache: 'no-cache' }")
    fetch("/meta.json")
        .then((response) => response.json())
        .then((meta) => {
            const latestVersionDate = meta.buildDate;
            const currentVersionDate = packageJson.buildDate;
            const shouldForceRefresh = buildDateGreaterThan(
                latestVersionDate,
                currentVersionDate
            );
            if (shouldForceRefresh) {
                isLatestBuildDate = false;
                refreshCacheAndReload();
            } else {
                isLatestBuildDate = true;
            }
        });
    var isLoginPath = Path === "/";
    if(window.location.search != "" && window.location.search != null)
        sessionStorage.setItem("QueryTag", window.location.search);
    if (isNullOrUndefined(sessionStorage.getItem('UserInfo')) && !isLoginPath && Path != "/forgotpassword") {      
        return <Redirect to="/" />;
    }
    else if (!isNullOrUndefined(sessionStorage.getItem('UserInfo')) && Path === "/") { 
        return <Redirect to="/home" />;
    }
       
    return <Route {...rest} render={props => (
        <Layout> 
            <Component {...props} />
        </Layout>
    )} />;   
}